import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-white/10 bg-[#07090c] text-foreground">
      <div className="page-shell py-14 sm:py-20">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-8">
          <div className="lg:col-span-7">
            <p className="eyebrow">Available for select projects</p>
            <a
              href="mailto:gregk2013@gmail.com"
              className="group mt-6 inline-flex max-w-3xl items-end gap-4 text-4xl font-semibold leading-tight tracking-[-0.04em] transition hover:text-ember sm:text-6xl"
            >
              Let’s work together
              <ArrowUpRight className="mb-1 h-8 w-8 shrink-0 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1 sm:h-10 sm:w-10" />
            </a>
          </div>
          <div className="grid grid-cols-2 gap-8 text-sm lg:col-span-5 lg:pl-12">
            <div>
              <p className="footer-label">Explore</p>
              <div className="mt-5 flex flex-col gap-3 text-white/60">
                <Link className="footer-link" to="/3dexcite">
                  3DExcite
                </Link>
                <Link className="footer-link" to="/demo-reel">
                  Reel
                </Link>
                <Link className="footer-link" to="/other-works">
                  Archive
                </Link>
                <Link className="footer-link" to="/about">
                  About
                </Link>
              </div>
            </div>
            <div>
              <p className="footer-label">Contact</p>
              <div className="mt-5 flex flex-col gap-3 text-white/60">
                <a className="footer-link" href="mailto:gregk2013@gmail.com">
                  Email
                </a>
                <a className="footer-link" href="tel:+18183700033">
                  +1 818 370 0033
                </a>
                <span>Los Angeles, CA</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-6 text-[10px] font-semibold uppercase tracking-[0.18em] text-white/30 sm:mt-24 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Gregory Kalamdaryan</p>
          <p>FX · Simulation · Compositing</p>
        </div>
      </div>
    </footer>
  );
};
